export const COURSELANDING_PAGE_START = 'COURSELANDING_PAGE_START';
export const COURSELANDING_PAGE_SUCCESS = 'COURSELANDING_PAGE_SUCCESS';
export const COURSELANDING_PAGE_FAILED = 'COURSELANDING_PAGE_FAILED';
export const TOGGLE_FAQ = 'TOGGLE_FAQ';
